import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Initialize i18next with configuration
i18n
  .use(LanguageDetector) // optional: detect user language automatically
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    fallbackLng: 'en',
    // debug: true,
    resources: {
      en: {
        translation: require('./locales/en/translation.json')
      },
      it: {
        translation: require('./locales/it/translation.json')
      }
    },
    interpolation: {
      escapeValue: false // React already does escaping
    }
  });

export default i18n;
